// @flow
import { PRODUCT_TAGS } from 'Client/cms/toolkit/constants';
import { ProductTagsLine } from 'Components/lines/product-tags-line/ProductTagsLine';
import { productTagsResolver } from './productTags.resolver';

export const productTagsDescriptor = {
  name: PRODUCT_TAGS,
  component: ProductTagsLine,
  resolver: productTagsResolver.resolve,
};
